import { AddPeoplePage, LastWorkspaceResolver, LazyPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function AddPeopleRoute() {
  return (
    <LastWorkspaceResolver>
      <LazyPage>
        <AddPeoplePage />
      </LazyPage>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/home/add-people')({
  component: AddPeopleRoute,
});
